import * as React from "react";

import "./terms-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";
import {ModalService3}  from "@Common/ui-components/modal-service-3/modal-service-3";

export const TermsModal = ({next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3({
        xdQaName: "Terms Modal",
        top: 20,
        width: 800,
        next, rootNext,
    })],
    consumeContext("apis"),
    ["customerAgreement", ({apis}, next) => Load2({
        fetch: () => apis.next.getCustomerAgreement('subscription'),
        next,
    })],
    ({customerAgreement}) => (
        <div className="terms-modal-i9e" xd-qa-type="modal" xd-qa-name="Terms">
            <h1 style={{ minHeight: "35px"}} xd-qa-type="label" xd-qa-name="Terms">Subscription Terms</h1>
            <div className="content">
                {customerAgreement.loading && (
                    <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                        Loading...
                    </div>
                )}
                {customerAgreement?.value?.map((agreement, i) => (
                    <p className="" key={i} dangerouslySetInnerHTML={{
                        __html: agreement.description}}>
                    </p>
                ))}
            </div>
        </div>
    ),
);
